import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Dispatch, SetStateAction, useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import UnForm from "../../../../../Components/Form";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import {
    CadastrarPerguntasERespostasController,
    EditarPerguntasERespostasController,
    ListarTipoPerguntaFormularioController,
} from "../../../../../Controllers/Geral/Formularios/PerguntasERespostas/PerguntasERespostasControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import {
    ICadastrarPerguntasERespostas,
    IEditarPerguntasERespostasForm,
    IRespostaPesquisaSatisfacao,
} from "../../../../../Interfaces/Geral/Formularios/FormulariosInterface";
import { AlertConfirmation } from "../../../../../Tools/SweetAlerts";

interface ICadastrarPerguntasERespostasProps {
    idFormulario: number;
    setMostrarPerguntasERespostas: Dispatch<SetStateAction<boolean>>;
    perguntaERespostas?: IEditarPerguntasERespostasForm;
    setPerguntaSendoEditada: Dispatch<
        SetStateAction<IEditarPerguntasERespostasForm | undefined>
    >;
}

export default function CadastrarPerguntasERespostas(
    props: ICadastrarPerguntasERespostasProps
) {
    const [idTipoPergunta, setIdTipoPergunta] = useState(0);
    const [pergunta, setPergunta] = useState(props?.perguntaERespostas?.DS_PERGUNTA ?? '');

    const FormMethods = useForm<ICadastrarPerguntasERespostas>({
        defaultValues: props.perguntaERespostas
            ? { ...props.perguntaERespostas }
            : {
                PerguntasFilhas: [
                    {
                        PesquisaSatisfacaoRespostas: [
                            { DS_RESPOSTA: "", NR_PESO: undefined },
                        ],
                    },
                ],
            },
    });
    const { control } = FormMethods;
    const { fields, append, remove } =
        useFieldArray<IRespostaPesquisaSatisfacao>({
            name: "PesquisaSatisfacaoRespostas",
            control,
        });

    const { execute: executarFormCadastrarPerguntasERespostas, loading } =
        useAsyncCallback(CadastrarPerguntasERespostasController);

    const {
        execute: FormAtualizarPerguntasERespostas,
        loading: FormAtualizarPerguntasERespostasLoading,
    } = useAsyncCallback(EditarPerguntasERespostasController);

    const handleCadastrarPerguntasERespostasSubmit = (
        formData: ICadastrarPerguntasERespostas
    ) => {
        executarFormCadastrarPerguntasERespostas({
            ...formData,
            ID_FORMULARIO: props.idFormulario,
        }).then(() => {
            props.setMostrarPerguntasERespostas(true);
        });
    };

    const handleEditarPerguntasERespostasSubmit = (
        formData: IEditarPerguntasERespostasForm
    ) => {
        if (props.perguntaERespostas) {
            FormAtualizarPerguntasERespostas({
                ...formData,
                ID_PERGUNTA: props.perguntaERespostas?.ID_PERGUNTA,
                DS_PERGUNTA: pergunta,
                ID_FORMULARIO: props.perguntaERespostas.ID_FORMULARIO,
            }).then(() => {
                props.setMostrarPerguntasERespostas(true);
                props.setPerguntaSendoEditada(undefined);
            });
        }
    };

    return (
        <FormProvider {...FormMethods}>
            <h3>Cadastrar Perguntas e Respostas</h3>
            <UnForm
                handleSubmit={
                    props.perguntaERespostas
                        ? handleEditarPerguntasERespostasSubmit
                        : handleCadastrarPerguntasERespostasSubmit
                }
                usingContext
            >
                <h5 className="mb-4 ml-4">Perguntas</h5>
                <div className="mb-6">
                    <div className="row m-0 d-flex justify-content-center ">
                        <UnForm.LazySelect
                            onChange={(event) =>
                                setIdTipoPergunta(Number(event.target.value))
                            }
                            label="Tipo de Pergunta"
                            registerOptions={{
                                required: "Insira o Tipo da Sua Pergunta",
                            }}
                            wrapperClassName="col-12 col-md-12 m-0"
                            controller={ListarTipoPerguntaFormularioController}
                            name={
                                props.perguntaERespostas
                                    ? `ID_TIPO_PERGUNTA`
                                    : `ID_TIPO_PERGUNTA`
                            }
                            defaultValue={
                                props.perguntaERespostas?.ID_TIPO_PERGUNTA
                            }
                            getDS={(p) => p.DS_TIPO_PERGUNTA}
                            getKeyValue={(p) => p.ID_TIPO_PERGUNTA}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                </div>

                <div className="mb-6">
                    <div className="row m-0 ">
                        <UnForm.Textarea
                            registerOptions={{
                                required: "Insira a descrição de sua pergunta",
                            }}
                            name={`DS_PERGUNTA`}
                            label="Descreva sua Pergunta"
                            noRezise
                            rows={3}
                            onChange={(e) => setPergunta(e.target.value)}
                            defaultValue={
                                props.perguntaERespostas?.DS_PERGUNTA ?? ""
                            }
                            wrapperClassName="col-12 col-md-12 m-0"
                        />
                        <UnForm.Switch
                            color="primary"
                            wrapperClassName="ml-4 mt-2"
                            label="Pergunta Visível"
                            labelPosition="top"
                            type="checkbox"
                            name="FL_ATIVO"
                            defaultChecked={props.perguntaERespostas?.FL_ATIVO}
                        />
                    </div>
                </div>

                {idTipoPergunta !== 3 && (
                    <>
                        <hr />

                        <div className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-4 ml-4">Respostas</h5>

                            <span
                                className="cursor-pointer text-success mr-4 mb-4"
                                onClick={() => {
                                    append({
                                        DS_RESPOSTA: "",
                                        NR_PESO: undefined,
                                        ID_PERGUNTA:
                                            props.perguntaERespostas
                                                ?.ID_PERGUNTA,
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} size="lg" />{" "}
                                Adicionar Resposta
                            </span>
                        </div>

                        {fields.map((value, index) => (
                            <React.Fragment key={value.id}>
                                <div className="mb-6">
                                    <div className="row m-0 ">
                                        <UnForm.Textarea
                                            registerOptions={{
                                                required:
                                                    "Insira a sua resposta",
                                            }}
                                            name={
                                                props.perguntaERespostas
                                                    ? `PesquisaSatisfacaoRespostas.${index}.DS_RESPOSTA`
                                                    : `PesquisaSatisfacaoRespostas.${index}.DS_RESPOSTA`
                                            }
                                            label="Crie uma resposta para sua pergunta"
                                            noRezise
                                            defaultValue={value.DS_RESPOSTA}
                                            rows={3}
                                            wrapperClassName="col-12 col-md-12 m-0"
                                        />
                                        <UnForm.Switch
                                            color="primary"
                                            wrapperClassName="ml-4 mt-2"
                                            label="Pergunta Visível"
                                            labelPosition="top"
                                            type="checkbox"
                                            name={
                                                props.perguntaERespostas
                                                    ? `PesquisaSatisfacaoRespostas.${index}.FL_ATIVO`
                                                    : `PesquisaSatisfacaoRespostas.${index}.FL_ATIVO`
                                            }
                                            defaultChecked={value.FL_ATIVO}
                                        />
                                    </div>
                                </div>
                                <div className="mb-6">
                                    <div className="row m-0 d-flex justify-content-between">
                                        <UnForm.Input
                                            registerOptions={{
                                                required:
                                                    "Insira o peso de sua pergunta",
                                            }}
                                            name={
                                                props.perguntaERespostas
                                                    ? `PesquisaSatisfacaoRespostas.${index}.NR_PESO`
                                                    : `PesquisaSatisfacaoRespostas.${index}.NR_PESO`
                                            }
                                            defaultValue={value.NR_PESO}
                                            label="Peso"
                                            wrapperClassName="col-4 col-md-4 m-0"
                                        />

                                        {props.perguntaERespostas ||
                                            fields.length > 1 ? (
                                            <div className="Button-Tools mt-6">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger font-weight-bold mr-2 w-100px"
                                                    onClick={() => {
                                                        remove(index);
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faTrash}
                                                        size="lg"
                                                    />{" "}
                                                    Excluir
                                                </button>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <UnForm.Input
                                    readOnly={true}
                                    name={
                                        props.perguntaERespostas
                                            ? `PesquisaSatisfacaoRespostas.${index}.ID_RESPOSTA`
                                            : `PesquisaSatisfacaoRespostas.${index}.ID_RESPOSTA`
                                    }
                                    className="d-none"
                                    value={value.ID_RESPOSTA ?? 0}
                                />
                                <UnForm.Input
                                    readOnly={true}
                                    name={
                                        props.perguntaERespostas
                                            ? `PesquisaSatisfacaoRespostas.${index}.ID_PERGUNTA`
                                            : ""
                                    }
                                    className="d-none"
                                    value={value.ID_PERGUNTA}
                                />
                            </React.Fragment>
                        ))}
                    </>
                )}

                <div className="Button-Tools ">
                    <button
                        type="button"
                        className="btn btn-outline-primary font-weight-bold mr-2 w-100px"
                        onClick={() => {
                            AlertConfirmation(
                                "Estas mudanças serão canceladas",
                                "Confirmar?",
                                "warning"
                            ).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                    props.setMostrarPerguntasERespostas(
                                        result.isConfirmed
                                    );
                                    props.setPerguntaSendoEditada(undefined);
                                }
                            });
                        }}
                    >
                        Cancelar
                    </button>

                    <button
                        type="submit"
                        className="btn btn-success font-weight-bold mr-2 w-100px"
                        disabled={
                            loading || FormAtualizarPerguntasERespostasLoading
                        }
                    >
                        {props.perguntaERespostas ? "Editar" : "Salvar"}{" "}
                        <OrSpinner
                            loading={
                                loading ||
                                FormAtualizarPerguntasERespostasLoading
                            }
                            children={undefined}
                            loadingSize="sm"
                        />
                    </button>
                </div>
            </UnForm>
        </FormProvider>
    );
}
